import { useEffect, useState } from 'react';
import { useDatabase } from './useDatabase';

export interface ProductDetails {
  id: string;
  name: string;
  description: string | undefined;
  draft: boolean;
  lifecycleStage: string | undefined;
  createdAt: string;
  remoteReference: { provider: string; url: string } | undefined;
}

export function useProduct(productId: string | undefined) {
  const { database, loading: databaseLoading } = useDatabase();
  const [product, setProduct] = useState<ProductDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!database || !productId) {
      if (!database) setLoading(false);
      return;
    }

    try {
      const products = database.projects();
      const obj = products[productId];

      if (!obj) {
        setError(`Product with ID ${productId} not found`);
        setProduct(null);
      } else {
        const ref = obj.remote_reference();
        setProduct({
          id: productId,
          name: obj.name(),
          description: obj.description() ?? undefined,
          draft: obj.draft(),
          lifecycleStage: obj.lifecycle_stage() ?? undefined,
          createdAt: obj.created_at(),
          remoteReference: ref ? { provider: ref.provider, url: ref.url } : undefined,
        });
        setError(null);
      }
    } catch (err) {
      console.error('Error fetching product:', err);
      setError(`Error fetching product: ${err}`);
      setProduct(null);
    } finally {
      setLoading(false);
    }
  }, [database, productId]);

  return { product, loading: loading || databaseLoading, error };
}
